import { AxiosError } from "axios";
import { useMutation, UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useAuthToken } from "capitalrx-shell";

import { useFailureHandler } from "../hooks";
import { fetch } from "./fetch";

const useApiMutate = <Request, Response>(
  url: string,
  apiCall: (request: Request, authToken: string, url: string) => Promise<Response>,
  options?: UseMutationOptions<Response, AxiosError, Request>,
): UseMutationResult<Response, AxiosError, Request> => {
  const [authToken] = useAuthToken();
  const failureHandler = useFailureHandler();

  return useMutation({
    mutationFn: (request: Request) => {
      return apiCall(request, authToken, url);
    },
    onError: failureHandler,
    ...options,
  });
};

export const createMutate = <Request, Response>(url: string) => {
  const useMutateQuery = (options?: UseMutationOptions<Response, AxiosError, Request>) => {
    const defaultOptions = options ? options : {};
    const apiCall = fetch;

    return useApiMutate(url, apiCall, { ...defaultOptions });
  };

  return useMutateQuery;
};
